import { runDemo } from "../shared/demoRunner";
import { createPbrGlossyBloomScene } from "./scene";

runDemo({ createScene: createPbrGlossyBloomScene });
